<template>
  <header class="main-header">
    <div class="container">
      <div class="header-left">
        <div class="logo">
          <router-link to="/"></router-link>
        </div>
        <nav class="nav">
          <router-link to="/" exact>首页</router-link>
          <router-link to="/ticket">购票</router-link>
          <!-- <a href="./live.html" target="_blank" style="color:red;font-weight:bold;">直播间</a> -->
          <router-link to="/exhibition">展览</router-link>
          <router-link to="/notes">笔记</router-link>
          <!-- <router-link to="/artwork">作品</router-link> -->
          <router-link to="/about">关于我们</router-link>
          <router-link to="/download" class="app" @mouseenter.native="showApp" @mouseleave.native="hideApp">下载APP
            <span class="qr-code" v-show="isShow"><img src="../../../assets/img/icon/nav_app_qrcode.png" width="152" height="179"></span>
            <!-- <span class="qr-code" v-show="isShow"><img src="../../../assets/img/icon/nav_liv_qrcode.jpg" width="300" height="179"></span> -->
          </router-link>
        </nav>
      </div>
      <div class="header-right">
        <div class="user-panel" v-if="userInfo">
          <div class="pic"><img :data-src="userInfo.logoUrl | imageUrl" :src="userInfo.logoUrl | imageUrl('?imageView2/1/w/60/h/60', './assets/img/header_user.png')" /></div>
          <div class="content">
            <span>{{userInfo.nickName}}</span>
            <span>
              <a href="../webapp/#/my/order">我的订单</a>
            </span>
            <span>
              <router-link to="/admin">进入后台</router-link>
            </span>
            <span class="logout" @click="onLogout">退出</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import Cookies from 'js-cookie'
import { logout, getShareAppToken, heartbeat } from '@/api/zaiart'

export default {
  data() {
    return {
      isShow: false,
      userInfo: null
    }
  },
  watch: {
    $route: function(route) {
      this.userInfo =
        (localStorage.getItem('userInfo') &&
          JSON.parse(localStorage.getItem('userInfo'))) ||
        null
    }
  },
  methods: {
    showApp() {
      this.isShow = true
    },
    hideApp() {
      this.isShow = false
    },
    //  退出登录
    onLogout() {
      logout().then(response => {
        this.$message({
          type: 'success',
          message: '退出成功'
        })
        localStorage.clear()
        this.$router.push({ path: '/', query: { logout: +new Date() } })
      })
    },
    checkToken() {
      heartbeat()
        .then(response => {
          getShareAppToken().then(response => {
            Cookies.set('token', response.data.token, {
              domain: process.env.VUE_APP_COOKIES_DOMAIN,
              expires: 365
            })
          })
        })
        .catch(response => {
          localStorage.clear()
        })
    }
  },
  created() {
    this.checkToken()
    this.userInfo =
      (localStorage.getItem('userInfo') &&
        JSON.parse(localStorage.getItem('userInfo'))) ||
      null
  }
}
</script>
<style>
.main-header {
  height: 64px;
  background-color: #fff;
  box-shadow: inset 0 -0.5px 0 0 rgba(0, 0, 0, 0.2);
}

.main-header .container {
  position: relative;
  max-width: 1200px;
  min-width: 1000px;
  margin: 0 auto;
}
.main-header .header-left {
  float: left;
}
.main-header .logo {
  float: left;
  width: 102px;
  height: 64px;
  background: url('../../../assets/img/icon/logo-slogan.png') no-repeat left
    10px;
  background-size: contain;
}

.main-header .logo a {
  display: block;
  height: 100%;
}

.main-header .nav {
  float: left;
  padding-left: 46px;
}

.main-header .nav a {
  position: relative;
  display: inline-block;
  margin: 0 16px;
  padding: 20px 8px 22px;
  font-size: 16px;
  line-height: 22px;
  color: #333;
}

.main-header .nav a.app {
  padding-right: 20px;
  background: url('../../../assets/img/icon/nav_app.png') no-repeat right center;
  background-size: 9px 14px;
}

.main-header .nav a:hover,
.main-header .nav a.router-link-active {
  color: #1b5ffe;
}

.main-header .qr-code {
  position: absolute;
  left: 50%;
  top: 48px;
  transform: translateX(-50%);
  z-index: 2;
}

.main-header .qr-code:hover {
  cursor: none;
}

.main-header .nav a.router-link-active:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  background-color: #1b5ffe;
}
.main-header .header-right {
  float: right;
}
.main-header .user-panel {
  padding: 17px 0;
  height: 30px;
}
.main-header .user-panel .pic {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.main-header .user-panel .pic img {
  width: 100%;
  height: 100%;
}
.main-header .user-panel .content {
  margin-left: 30px;
  font-size: 14px;
  color: #3c3c3c;
}
.main-header .user-panel .content span {
  display: inline-block;
  margin: 8px 0;
  padding: 0 10px;
  height: 14px;
  line-height: 14px;
  border-left: 1px solid #d8d8d8;
}
.main-header .user-panel .content span:first-child {
  border-left: none;
}
.main-header .user-panel .logout {
  cursor: pointer;
  color: #333;
}
</style>
